export const LOCAL_STORAGE_ACCESS_TOKEN = 'LOGIX_FORMS_ACCESS_TOKEN';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'LOGIX_FORMS_REFRESH_TOKEN';
// Set when forms stores a JWT handed to it in the URL by another app. Marks the
// session as borrowed, so it can be cleared again when that tab is done.
export const LOCAL_STORAGE_BORROWED_SESSION = 'LOGIX_FORMS_BORROWED_SESSION';
export const LOCAL_STORAGE_LAST_RESET_PASSWORD_TIMESTAMP =
  'LOCAL_STORAGE_LAST_RESET_PASSWORD_TIMESTAMP';
